"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Loading = function () {
    return (react_1.default.createElement("div", { className: "loading" },
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" },
            react_1.default.createElement("circle", { cx: "50", cy: "50", r: "40" }))));
};
exports.default = Loading;
